import { Injectable } from '@angular/core';
import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';

@Injectable()
export class DynamicFieldService {

	constructor(private dataService: DataService, private bs: BaseService) {
		this.bs.log('info', "Loaded dynamic field Service");
	}

	getEntityDynamicFieldFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'DynamicField/GetEntityDynamicField';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {				
				this.bs.log('info', "Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error', err);
				this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	}
}
